module.exports = __webpack_public_path__ + "img/preview.4febd076.png";